import ApiService from '@/services/apiService';
import tenantPickerMixin from '@/components/core/tenant/pickerMixin';
import cloneDeep from 'lodash/cloneDeep';
import routerPaths from '@/router/paths';
import drawerLinksMixin from '@/components/core/drawerLinks';
export default {
  name: 'ViewAccountMgmtAccountMgmtDrawerLinks',
  mixins: [tenantPickerMixin, drawerLinksMixin],
  data() {
    return {
      formIsValid: false,
      isSaving: false,
      tenantTheme: {}
    };
  },
  computed: {
    headerBG() {
      return './img/dtwin-factory1.png';
    },
    drawerIconLinks() {
      return routerPaths.map(item => ({
        ...item,
        name: this.$i18n_t(item.name)
      }));
    }
  },
  watch: {
    selectedTenantId() {
      if (this.selectedTenantId === undefined) {
        return;
      }
      const tenant = this.getTenantById(this.selectedTenantId);
      this.tenantTheme = tenant.data && tenant.data.theme || {};
      this.refreshDrawerLinks();
    }
  },
  mounted() {
    this.loadTenants();
  },
  methods: {
    refreshDrawerLinks() {
      this.tenantTheme = cloneDeep(this.tenantTheme);
      this.processDrawerLinks();
    },
    resetDrawerLinks() {
      this.tenantTheme.drawerLinks = null;
      this.refreshDrawerLinks();
    },
    createDrawerLinksConfig() {
      this.tenantTheme.drawerLinks = [];
      this.refreshDrawerLinks();
    },
    defaultDrawerLinksConfig() {
      this.tenantTheme.drawerLinks = cloneDeep(this.links);
      this.refreshDrawerLinks();
    },
    processDrawerLinks() {
      const doProcess = links => {
        links.forEach(linkItem => {
          if (linkItem.category && !linkItem.type) {
            linkItem.type = 'category';
          } else if (!linkItem.to && !linkItem.type) {
            linkItem.type = 'group';
            if (!linkItem.children) {
              linkItem.children = [];
            }
          } else if (linkItem.to && !linkItem.type) {
            linkItem.type = 'link';
          }
          if (!linkItem.permissionsJsonString) {
            linkItem.permissionsJsonString = JSON.stringify(linkItem.permissions || {}, null, 1);
          }
          if (linkItem.children) {
            doProcess(linkItem.children);
          }
        });
      };
      if (this.tenantTheme.drawerLinks) {
        doProcess(this.tenantTheme.drawerLinks);
      }
    },
    saveDrawerLinks() {
      const doClean = (links, org) => {
        (links || []).forEach((linkItem, index) => {
          if (linkItem.type === 'category') {
            delete linkItem.permissionsJsonString;
            delete linkItem.permissions;
            delete linkItem.children;
          }
          if (linkItem.type === 'group') {
            delete linkItem.permissionsJsonString;
            delete linkItem.permissions;
            delete linkItem.type;
          }
          if (linkItem.type === 'link') {
            try {
              linkItem.permissions = JSON.parse(linkItem.permissionsJsonString);
            } catch (e) {
              org[index].permissionJsonError = e;
              this.formIsValid = false;
            }
            delete linkItem.permissionsJsonString;
            delete linkItem.children;
          }
          delete linkItem.type;
          if (linkItem.children) {
            doClean(linkItem.children, org[index].children);
          }
        });
      };
      const cleanedDrawerLinks = cloneDeep(this.tenantTheme.drawerLinks);
      doClean(cleanedDrawerLinks, this.tenantTheme.drawerLinks);
      if (!this.formIsValid) {
        this.refreshDrawerLinks();
        this.$snack('INVALID PERMISSION JSON', 'error');
        return;
      }
      this.isSaving = true;
      // Actually update the tenant
      return ApiService.tenantGetById(this.selectedTenantId, ['no-scope-descendents']).then(result => {
        const tenantObj = result;
        if (!tenantObj.data) {
          tenantObj.data = {};
        }
        tenantObj.data.theme = {
          ...tenantObj.data.theme,
          drawerLinks: cleanedDrawerLinks
        };
        return ApiService.tenantUpdate(this, result);
      }).then(() => {
        // store saved theme data to tenant state
        const tenantIdx = this.getTenantIdxById(this.selectedTenantId);
        this.tenants[tenantIdx].data.theme = this.tenantTheme;
        this.refreshDrawerLinks();
        this.isSaving = false;
        this.$snack(this.$i18n_t('accMgmt.system.saveSucess'), 'success');
      }).catch(error => {
        console.error(error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('accMgmt.system.errorSave'), 'error');
        }
        this.isSaving = false;
      });
    }
  }
};